import { makeStyles } from '@material-ui/core'

const styles = ({ clientPortalTheme }) =>
  makeStyles((theme) => ({
    buttonPrimaryBlue: {
      padding: theme.spacing(1.5, 2),
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(15),
      backgroundColor: theme.palette.primary.main,
      color: clientPortalTheme
        ? theme.palette.primary.contrastText
        : theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    buttonPrimaryWhite: {
      padding: theme.spacing(1.5, 2),
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(15),
      backgroundColor: clientPortalTheme
        ? theme.palette.primary.contrastText
        : theme.palette.common.white,
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        backgroundColor: clientPortalTheme
          ? theme.palette.primary.contrastText
          : theme.palette.common.white,
      },
    },
    actionButtons: {
      display: 'flex',
      gap: theme.spacing(2),
    },
    buttonBack: {
      padding: theme.spacing(1.5, 2),
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      '&:hover': {
        borderColor: theme.palette.primary.dark,
        backgroundColor: theme.palette.action.hover,
      },
    },
    inputWhite: {
      backgroundColor: clientPortalTheme
        ? theme.palette.primary.contrastText
        : theme.palette.common.white,
      border: 'none',
      borderRadius: 5,
      '& input': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(19),
        padding: 10,
        fontWeight: 700,
      },
    },
  }))

export default styles
